import { axiosGet, axiosPost } from '../axios/config';

export const getThemeSetting = (data) => {
  return axiosGet(`/theme-setting`, data);
};

export const addThemeSetting = (data) => {
  return axiosPost('/theme-setting/add', data);
};
